var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { combine } from 'zustand/middleware';
import { ChatMessageDeliveryStatus } from '../types';
var getUnreadBoundaryMessageId = function (data, unreadCount, lastReadAt) {
    var _a, _b;
    return unreadCount > 0
        ? (_b = (_a = (lastReadAt
            ? data.messages.find(function (_a) {
                var sentAt = _a.sentAt;
                return new Date(sentAt) > new Date(lastReadAt);
            })
            : data.messages[Math.max(0, data.messages.length - unreadCount)])) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null
        : null;
};
export var customActions = function (initialValues) {
    return combine(initialValues, function (setState) { return ({
        setChatId: function (chatId) {
            return setState(function (state) {
                var _a;
                return (__assign(__assign({}, state), { chatId: chatId, error: null, beforeSentAt: null, content: [], nextCursor: null, hasMore: true, isAtBottom: true, newMessagesCount: 0, isSearchOpen: false, isSearchLoading: false, searchResultIndex: 0, searchResults: [], searchString: '', searchQuery: '', unreadBoundaryMessageId: chatId ? (_a = state.unreadBoundaryMessageIds[chatId]) !== null && _a !== void 0 ? _a : null : null, initialized: false, loading: Boolean(chatId), isPreviousPageLoading: false }));
            });
        },
        setBeforeSentAt: function (beforeSentAt) {
            return setState(function (state) { return (__assign(__assign({}, state), { beforeSentAt: beforeSentAt, loading: true, isPreviousPageLoading: true })); });
        },
        setMessages: function (data, unreadCount, lastReadAt) {
            if (unreadCount === void 0) { unreadCount = 0; }
            return setState(function (state) {
                var _a;
                var _b;
                var unreadBoundaryMessageId = state.initialized
                    ? state.unreadBoundaryMessageId
                    : (_b = state.unreadBoundaryMessageId) !== null && _b !== void 0 ? _b : getUnreadBoundaryMessageId(data, unreadCount, lastReadAt);
                return __assign(__assign({}, state), { error: null, content: data.messages, newMessagesCount: state.initialized ? state.newMessagesCount : unreadCount, unreadBoundaryMessageId: unreadBoundaryMessageId, unreadBoundaryMessageIds: state.chatId && unreadBoundaryMessageId
                        ? __assign(__assign({}, state.unreadBoundaryMessageIds), (_a = {}, _a[state.chatId] = unreadBoundaryMessageId, _a)) : state.unreadBoundaryMessageIds, nextCursor: data.nextCursor, hasMore: data.hasMore, loading: false, initialized: true, isPreviousPageLoading: false });
            });
        },
        prependMessages: function (data) {
            return setState(function (state) { return (__assign(__assign({}, state), { content: __spreadArray(__spreadArray([], data.messages.filter(function (message) { return !state.content.some(function (_a) {
                    var id = _a.id;
                    return id === message.id;
                }); }), true), state.content, true), nextCursor: data.nextCursor, hasMore: data.hasMore, loading: false, initialized: true, isPreviousPageLoading: false })); });
        },
        appendMessage: function (message, markUnread) {
            if (markUnread === void 0) { markUnread = false; }
            return setState(function (state) {
                var _a;
                if (state.content.some(function (_a) {
                    var id = _a.id;
                    return id === message.id;
                }))
                    return state;
                var pendingMessageIndex = message.isSystem
                    ? -1
                    : state.content.findIndex(function (item) {
                        return 'deliveryStatus' in item &&
                            item.deliveryStatus === ChatMessageDeliveryStatus.Sending &&
                            item.author.id === message.author.id &&
                            item.text === message.text;
                    });
                var unreadBoundaryMessageId = markUnread && !state.unreadBoundaryMessageId ? message.id : state.unreadBoundaryMessageId;
                return __assign(__assign({}, state), { content: pendingMessageIndex >= 0
                        ? state.content.map(function (item, index) { return (index === pendingMessageIndex ? message : item); })
                        : __spreadArray(__spreadArray([], state.content, true), [message], false), unreadBoundaryMessageId: unreadBoundaryMessageId, unreadBoundaryMessageIds: markUnread && state.chatId && unreadBoundaryMessageId
                        ? __assign(__assign({}, state.unreadBoundaryMessageIds), (_a = {}, _a[state.chatId] = unreadBoundaryMessageId, _a)) : state.unreadBoundaryMessageIds, newMessagesCount: markUnread ? state.newMessagesCount + 1 : state.newMessagesCount, loading: false });
            });
        },
        confirmLocalMessage: function (localId, message) {
            return setState(function (state) {
                var content = state.content.filter(function (_a) {
                    var id = _a.id;
                    return id !== localId;
                });
                return __assign(__assign({}, state), { content: content.some(function (_a) {
                        var id = _a.id;
                        return id === message.id;
                    })
                        ? content.map(function (item) { return (item.id === message.id ? message : item); })
                        : __spreadArray(__spreadArray([], content, true), [message], false), loading: false });
            });
        },
        setLocalMessage: function (message) {
            return setState(function (state) { return (__assign(__assign({}, state), { content: state.content.some(function (_a) {
                    var id = _a.id;
                    return id === message.id;
                })
                    ? state.content.map(function (existingMessage) { return (existingMessage.id === message.id ? message : existingMessage); })
                    : __spreadArray(__spreadArray([], state.content, true), [message], false) })); });
        },
        failLocalMessage: function (messageId) {
            return setState(function (state) { return (__assign(__assign({}, state), { loading: false, content: state.content.map(function (message) {
                    return message.id === messageId && 'deliveryStatus' in message
                        ? __assign(__assign({}, message), { deliveryStatus: ChatMessageDeliveryStatus.Failed }) : message;
                }) })); });
        },
        rememberUnreadMessage: function (chatId, messageId) {
            return setState(function (state) {
                var _a;
                return (__assign(__assign({}, state), { unreadBoundaryMessageIds: state.unreadBoundaryMessageIds[chatId]
                        ? state.unreadBoundaryMessageIds
                        : __assign(__assign({}, state.unreadBoundaryMessageIds), (_a = {}, _a[chatId] = messageId, _a)) }));
            });
        },
        setIsAtBottom: function (isAtBottom) { return setState(function (state) { return (__assign(__assign({}, state), { isAtBottom: isAtBottom })); }); },
        clearNewMessages: function () {
            return setState(function (state) {
                var unreadBoundaryMessageIds = __assign({}, state.unreadBoundaryMessageIds);
                if (state.chatId)
                    delete unreadBoundaryMessageIds[state.chatId];
                return __assign(__assign({}, state), { newMessagesCount: 0, unreadBoundaryMessageId: null, unreadBoundaryMessageIds: unreadBoundaryMessageIds });
            });
        },
        openSearch: function () { return setState(function (state) { return (__assign(__assign({}, state), { isSearchOpen: true })); }); },
        closeSearch: function () {
            return setState(function (state) { return (__assign(__assign({}, state), { isSearchOpen: false, isSearchLoading: false, searchResultIndex: 0, searchResults: [], searchString: '', searchQuery: '' })); });
        },
        changeSearchString: function (searchString) {
            return setState(function (state) { return (__assign(__assign({}, state), { searchResultIndex: 0, searchString: searchString })); });
        },
        applySearchQuery: function (searchQuery) {
            return setState(function (state) { return (__assign(__assign({}, state), { searchQuery: searchQuery, searchResultIndex: 0, searchResults: searchQuery ? state.searchResults : [] })); });
        },
        setSearchLoading: function (isSearchLoading) { return setState(function (state) { return (__assign(__assign({}, state), { isSearchLoading: isSearchLoading })); }); },
        setSearchResults: function (searchResults) {
            return setState(function (state) { return (__assign(__assign({}, state), { searchResultIndex: Math.max(searchResults.length - 1, 0), searchResults: __spreadArray([], searchResults, true).sort(function (first, second) { return new Date(first.sentAt).getTime() - new Date(second.sentAt).getTime(); }) })); });
        },
        showPreviousSearchResult: function () {
            return setState(function (state) { return (__assign(__assign({}, state), { searchResultIndex: Math.max(state.searchResultIndex - 1, 0) })); });
        },
        showNextSearchResult: function () {
            return setState(function (state) { return (__assign(__assign({}, state), { searchResultIndex: Math.min(state.searchResultIndex + 1, state.searchResults.length - 1) })); });
        },
        editMessage: function (message) {
            return setState(function (state) { return (__assign(__assign({}, state), { content: state.content.map(function (item) { return (item.id === message.id ? message : item); }), loading: false })); });
        },
        removeMessage: function (messageId) {
            return setState(function (state) { return (__assign(__assign({}, state), { content: state.content.filter(function (_a) {
                    var id = _a.id;
                    return id !== messageId;
                }) })); });
        },
        resetMessages: function () {
            return setState(function (state) { return (__assign(__assign({}, state), { chatId: null, beforeSentAt: null, content: [], nextCursor: null, hasMore: true, isAtBottom: true, newMessagesCount: 0, isSearchOpen: false, isSearchLoading: false, searchResultIndex: 0, searchResults: [], searchString: '', searchQuery: '', unreadBoundaryMessageId: null, unreadBoundaryMessageIds: {}, initialized: false, loading: false, isPreviousPageLoading: false })); });
        },
    }); });
};
